import {
    TextInput,
    SimpleForm,
    useCreate,
    useNotify,
    Link,
    useRedirect,
    useDataProvider, required, FunctionField
} from "react-admin";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {LocalizationActions} from "../../../Component/Layouts/LocalizationActions";
import {useParams} from "react-router-dom";
import setLoadStatus from "../../../Store/LoaderReducer";
import {useDispatch} from "react-redux";

const LOCALIZATION_DATA = {
    id: '',
    name: '',
    image_url: '',
    horizontal_image_url: '',
}

const CategoryLocalization = () => {
    const { '*': locale, id } = useParams();
    const initialRef = useRef(true);
    const [localizationData, setLocalizationData] = useState({[locale]: LOCALIZATION_DATA});
    const [create] = useCreate();
    const notify = useNotify();
    const redirect = useRedirect();
    const dataProvider = useDataProvider();
    const dispatch = useDispatch();

    const formData = {
        name: '',
        image: '',
        horizontal_image: '',
    };

    useEffect(() => {
        if (!initialRef.current) {
            return;
        }
        initialRef.current = false;

        dataProvider.getOne('categories', {id: `${id}/${locale}`}).then((res) => {
            setLocalizationData({[locale]: LOCALIZATION_DATA});
            if (res.data.id !== 0) {
                setLocalizationData({[locale]: res.data});
            }
        });
    }, [dataProvider, id, locale])

    const categoryLocalizationCreate = () => {
        if (!formData.name.length || !formData.image || !formData.horizontal_image) {
            if (!formData.name.length) {
                document.querySelector('.name').classList.add('error');
            }

            if (!formData.image.size) {
                document.querySelector('.image-required').classList.add('error');
            }

            if (!formData.horizontal_image.size) {
                document.querySelector('.horizontal_image-required').classList.add('error');
            }

            return;
        }
        dispatch(setLoadStatus(true));
        if (!localizationData[locale].id) {
            create(`categories/${id}/${locale}`, {data: {
                    name: formData.name,
                    image: formData.image,
                    horizontal_image: formData.horizontal_image,
                }}, {
                onSuccess: (res) => {
                    dispatch(setLoadStatus(false));
                    notify(`Category localization ${locale} created`);
                    redirect(`/categories/general/${id}`);
                },
                onError: (res) => {
                    dispatch(setLoadStatus(false));
                    notify(res.message, 'warning');
                }
            });
        }

        if (localizationData[locale].id) {
            dataProvider.update(`categories`, {id: `${id}/${locale}`, data: {
                    name: formData.name,
                    image: formData.image,
                    horizontal_image: formData.horizontal_image,
                }}).then(() => {
                dispatch(setLoadStatus(false));
                notify(`Category localization ${locale} update`);
                redirect(`/categories/general/${id}`);
            }).catch((res) => {
                dispatch(setLoadStatus(false));
                notify(res.message, 'warning');
            });
        }
    }

    const Save = ({...props}) => {
        return (
            <div className="dailyActionToolbar">
                {props.localizationId &&
                    <LocalizationActions id={id} status={props.localizationStatus} url={'categories'} redirectUrl={'/categories/general'} prefix={locale}/>
                }
                <Link to="/categories/general" className="button bar-purple-button">Cancel</Link>
                <button
                    onClick={categoryLocalizationCreate}
                    className="button bar-gradient-button"
                    type="button"
                >
                    <span>Save</span>
                </button>
            </div>
        );
    }

    const ImageUploadField = () => {
        const [imageSrc, setImageSrc] = useState(null);

        const uploadImage = async (imageFile) => {
            if (!imageFile) {
                return;
            }

            const mimeType = imageFile.type;
            const mimetypes = ['image/png', 'image/jpeg', 'image/jpg'];

            if (!mimetypes.includes(mimeType)) {
                notify(`Image should be in (.png, .jpeg, .jpg) formats.`, 'warning');
                return;
            }

            if (document.querySelector('.image-required').classList.contains('error')) {
                document.querySelector('.image-required').classList.remove('error');
            }

            formData.image = imageFile;

            const reader = new FileReader();

            reader.onload = () => {
                setImageSrc(reader.result);
            }

            reader.readAsDataURL(imageFile);
        }

        return <div className="form-field image-required">
            <span className="fieldTitle">Icon</span>
            <div>
                <div className="imageWrap">
                        <img
                            className="image"
                            src={imageSrc ? imageSrc : formData.image}
                            alt=""
                        />
                    <p className="required-text">Required</p>
                </div>
                <label className="imageLabel" htmlFor="imageInput"></label>
                <input
                    type="file"
                    id="imageInput"
                    className="fileInput"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={(e) => uploadImage(e.currentTarget.files[0])}
                />
                <label htmlFor="imageInput" className="uploadButton">
                    {formData.image ? 'Update Image' : 'Choose an Image'}
                </label>
            </div>
        </div>;
    }

    const HorizontalImageUploadField = () => {
        const [horizontalImageSrc, setHorizontalImageSrc] = useState(null);

        const uploadImage = async (imageFile) => {
            if (!imageFile) {
                return;
            }

            const mimeType = imageFile.type;
            const mimetypes = ['image/png', 'image/jpeg', 'image/jpg'];

            if (!mimetypes.includes(mimeType)) {
                notify(`Image should be in (.png, .jpeg, .jpg) formats.`, 'warning');
                return;
            }

            if (document.querySelector('.horizontal_image-required').classList.contains('error')) {
                document.querySelector('.horizontal_image-required').classList.remove('error');
            }

            formData.horizontal_image = imageFile;

            const reader = new FileReader();

            reader.onload = () => {
                setHorizontalImageSrc(reader.result);
            }

            reader.readAsDataURL(imageFile);
        }

        return <div className="form-field horizontal_image-required">
            <span className="fieldTitle">Horizontal Image</span>
            <div>
                <div className="imageWrap">
                    <img
                        className="image"
                        src={horizontalImageSrc ? horizontalImageSrc : formData.horizontal_image}
                        alt=""
                    />
                    <p className="required-text">Required</p>
                </div>
                <label className="imageLabel" htmlFor="imageInput"></label>
                <input
                    type="file"
                    id="horizontalImageInput"
                    className="fileInput"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={(e) => uploadImage(e.currentTarget.files[0])}
                />
                <label htmlFor="horizontalImageInput" className="uploadButton">
                    {formData.horizontal_image ? 'Update Image' : 'Choose an Image'}
                </label>
            </div>
        </div>;
    }

    const titleChange = (e) => {
        if (document.querySelector('.name').classList.contains('error')) {
            document.querySelector('.name').classList.remove('error');
        }
        formData.name = e.target.value;
    }

    return (
        <SimpleForm record={localizationData[locale]} toolbar={<></>}>
                <FunctionField label="" render={(record) => {
                    formData.name = record.name;
                    return <>
                        <TextInput className="formFields name" label="Title" name="name"
                               source="formData.name" fullWidth id="name" validate={required()}
                               onChange={(e) => {
                                   titleChange(e)
                               }} multiline/>
                        <p className="required-text">Required</p>
                    </>;
                }}/>
                <p className="uploadImageLabel"></p>
                <FunctionField label="" render={(record) => {
                    formData.image = record.image_url;
                    return <ImageUploadField />;
                }}/>
                <p className="uploadImageLabel"></p>
                <FunctionField label="" render={(record) => {
                    formData.horizontal_image = record.horizontal_image_url;
                    return <HorizontalImageUploadField />;
                }}/>
                <Save localizationId={localizationData[locale].id} localizationStatus={localizationData[locale].status} />
        </SimpleForm>
    );
}

export default CategoryLocalization;